import ScaleYourClinic from './scale-your-clinic-updated';

function App() {
  return <ScaleYourClinic />;
}

export default App;
